"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
var models_1 = require("../../models");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var sis_inline_communication_service_1 = require("./sis-inline-communication.service");
var settings_1 = require("./settings");
var operators_1 = require("rxjs/operators");
var zip_1 = require("rxjs/observable/zip");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var of_1 = require("rxjs/observable/of");
require("./inline-sis-table.component.scss");
var skynet_store_locales_impl_1 = require("@synisys/skynet-store-locales-impl");
var noop_1 = require("rxjs/util/noop");
var InlineSisTableComponent = /** @class */ (function (_super) {
    __extends(InlineSisTableComponent, _super);
    function InlineSisTableComponent(kbService, currentLanguageProvider, classifierService, languageService, deService, validationService, dialog, localeService) {
        var _this = _super.call(this) || this;
        _this.kbService = kbService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.classifierService = classifierService;
        _this.languageService = languageService;
        _this.deService = deService;
        _this.validationService = validationService;
        _this.dialog = dialog;
        _this.localeService = localeService;
        _this.metaFieldType = idm_kb_service_client_js_1.MetaFieldType;
        // TODO: replace this when specialized message is added for de
        _this.datePlaceholderKey = 'portfolio.filter.date.range.choose.date';
        _this._onDocumentDeleted = new core_1.EventEmitter();
        _this._onDocumentUploaded = new core_1.EventEmitter();
        _this._isDeletable = true;
        _this._isAddable = true;
        _this._isReadonly = false;
        _this._validations = [];
        _this._validationMessages = immutable_1.Map();
        _this._validationEmitter = new core_1.EventEmitter();
        _this.isActionMenuOpened = false;
        _this.selectedRow = null;
        _this.validationMessage = lodash_1.memoize(_this._validationMessage, validationCacheKeyResolver);
        return _this;
    }
    Object.defineProperty(InlineSisTableComponent.prototype, "onDocumentDeleted", {
        // <editor-fold desc="getters and setters">
        get: function () {
            return this._onDocumentDeleted;
        },
        set: function (documentUploaded) {
            if (!documentUploaded) {
                return;
            }
            this._onDocumentUploaded = documentUploaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "validationEmitter", {
        get: function () {
            return this._validationEmitter;
        },
        set: function (validationEmitter) {
            if (!validationEmitter) {
                return;
            }
            this._validationEmitter = validationEmitter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "onDocumentUploaded", {
        get: function () {
            return this._onDocumentUploaded;
        },
        set: function (documentUploaded) {
            if (documentUploaded) {
                this._onDocumentUploaded = documentUploaded;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "subFormKey", {
        get: function () {
            return this._subFormKey;
        },
        set: function (value) {
            this._subFormKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "colSystemNames", {
        get: function () {
            return this._colSystemNames;
        },
        set: function (value) {
            this._colSystemNames = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "isDeletable", {
        get: function () {
            return this._isDeletable;
        },
        set: function (value) {
            this._isDeletable = value === undefined ? true : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "actions", {
        get: function () {
            return this._actions;
        },
        set: function (value) {
            this._actions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "rowItems", {
        get: function () {
            return this._rowItems;
        },
        set: function (value) {
            this._rowItems = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "mainCategoryName", {
        get: function () {
            return this._mainCategoryName;
        },
        set: function (value) {
            this._mainCategoryName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "categoryName", {
        get: function () {
            return this._categoryName;
        },
        set: function (value) {
            this._categoryName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "isAddable", {
        get: function () {
            return this._isAddable;
        },
        set: function (value) {
            this._isAddable = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "validations", {
        get: function () {
            return this._validations;
        },
        set: function (value) {
            this._validations = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "isReadonly", {
        get: function () {
            return this._isReadonly;
        },
        set: function (value) {
            this._isReadonly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "deleteMessageTitleKey", {
        get: function () {
            return this._deleteMessageTitleKey;
        },
        set: function (value) {
            this._deleteMessageTitleKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "deleteMessageKey", {
        get: function () {
            return this._deleteMessageKey;
        },
        set: function (value) {
            this._deleteMessageKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "languages", {
        get: function () {
            return this._languages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableComponent.prototype, "fieldName", {
        get: function () {
            return this._fieldName;
        },
        set: function (value) {
            this._fieldName = value;
        },
        enumerable: true,
        configurable: true
    });
    // </editor-fold>
    InlineSisTableComponent.prototype.ngOnChanges = function (changes) {
        if (changes.validations) {
            this.onValidation(changes.validations.currentValue);
        }
        if (changes.colSystemNames &&
            this.isReady &&
            !lodash_1.isNil(this._allMetaFields) &&
            !lodash_1.isNil(this._requiredMetaFieldIds)) {
            this.digOutColumnsMetaFields(this._allMetaFields);
            this.handleHeader(this._requiredMetaFieldIds);
        }
    };
    InlineSisTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        var kbData$ = this.kbService.getMetaFields(this.categoryName);
        var entity$ = (this.deService.createBlankSubEntity(this.categoryName));
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        var languages$ = this.languageService.getInputLanguages();
        var requiredMetaFieldIds$ = this.validationService.getCategoryRequiredMetaFieldIds(this.categoryName);
        currentLanguage$
            .pipe(operators_1.mergeMap(function (currentLanguage) {
            _this.currentLanguage = currentLanguage;
            var localeInfo$ = _this.localeService.getLocaleInfo(currentLanguage.getId());
            return zip_1.zip(kbData$, entity$, localeInfo$, languages$, requiredMetaFieldIds$);
        }), operators_1.map(function (data) {
            _this._allMetaFields = data[0];
            data[0] = _this.digOutColumnsMetaFields(data[0]);
            return data;
        }), operators_1.map(function (data) {
            var entity = data[1], localeInfo = data[2], languages = data[3], metaFieldIds = data[4];
            _this._requiredMetaFieldIds = metaFieldIds;
            _this.handleHeader(metaFieldIds);
            _this.addItemIfEmpty(entity);
            _this.localeInfo = localeInfo;
            _this._languages = languages;
            _this.isReady = true;
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(noop_1.noop, console.log);
    };
    InlineSisTableComponent.prototype.inlineAdd = function () {
        var _this = this;
        this.deService
            .createBlankSubEntity(this.categoryName)
            .pipe(operators_1.mergeMap(function (subEntity) {
            if (_this._rowItems) {
                var observables = [of_1.of(undefined)];
                subEntity.setId(_this.getUniqueIdForSubEntity());
                _this._rowItems.push(subEntity);
                return combineLatest_1.combineLatest(observables);
            }
            else {
                throw Error('row items were not been initialized');
            }
        }), operators_1.catchError(function (err, o) {
            console.error(err);
            return o;
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(noop_1.noop, function (err) { return console.error(err); });
    };
    InlineSisTableComponent.prototype.openEditPopup = function (rowItem) {
        throw Error('Operation not supported');
    };
    InlineSisTableComponent.prototype.openAddPopup = function () {
        var _this = this;
        this.deService
            .createBlankSubEntity(this.categoryName)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (subEntity) {
            subEntity.setId(_this.getUniqueIdForSubEntity());
            _this.actions.openPopup(_this.form, _this.categoryName, _this.subFormKey, subEntity);
        }, function (err) { return console.error(err); });
    };
    InlineSisTableComponent.prototype.onDocumentUpload = function (id, row, documentField) {
        this.onDocumentUploaded.emit({
            id: id,
            entity: row,
            documentField: documentField.getSystemName(),
        });
    };
    InlineSisTableComponent.prototype.onDocumentDelete = function (id, row, documentField) {
        this.onDocumentDeleted.emit({
            id: id,
            entity: row,
            documentField: documentField.getSystemName(),
        });
    };
    InlineSisTableComponent.prototype.removeAction = function () {
        var _this = this;
        _super.prototype.removeAction.call(this);
        var id = this._rowToRemove.getId();
        this.columnMetaFields.forEach(function (colName) {
            _this.validationMessage.cache.delete(validationCacheKeyResolver(id, colName.getSystemName()));
            _this._validationMessages = _this._validationMessages.delete(id);
        });
    };
    InlineSisTableComponent.prototype.getCellId = function (row, index) {
        return this.id + '-' + row.getId() + '-' + index;
    };
    InlineSisTableComponent.prototype.isFieldRequired = function (systemName) {
        return this._requiredMetaFieldIds.some(function (metaFieldId) { return metaFieldId.getSystemName() === systemName; });
    };
    InlineSisTableComponent.prototype._validationMessage = function (entityId, fieldName) {
        if (!this._validations ||
            !this._validationMessages.has(entityId) ||
            !this._validationMessages.get(entityId).has(fieldName)) {
            return undefined;
        }
        return this._validationMessages
            .get(entityId)
            .get(fieldName)
            .join('\n');
    };
    InlineSisTableComponent.prototype.onValidation = function (validationsCurrent) {
        var _this = this;
        if (validationsCurrent && validationsCurrent.length > 0) {
            var subEntityValidations_1 = this.extractSubEntityValidations(validationsCurrent);
            var functionalValidations_1 = this.extractFunctionalValidations(validationsCurrent);
            this._validationMessages = immutable_1.Map().withMutations(function (mutable) {
                subEntityValidations_1.forEach(function (val) {
                    var rowValidationMap = mutable.get(val.getIdentity(), immutable_1.Map());
                    val.getRelatedMetaFieldIds().forEach(function (relatedMetaFieldId) {
                        var fieldName = relatedMetaFieldId.getSystemName();
                        var Validations = rowValidationMap.get(fieldName, []);
                        Validations.push(val
                            .getMessage()
                            .getValue(_this.currentLanguage.getId()));
                        rowValidationMap = rowValidationMap.set(fieldName, Validations);
                    });
                    mutable.set(val.getIdentity(), rowValidationMap);
                });
                functionalValidations_1.forEach(function (val) {
                    val
                        .getValidationDisplay()
                        .getFields()
                        .get('fields')['rows'].forEach(function (entityId) {
                        var rowMap = mutable.get(entityId, immutable_1.Map());
                        val
                            .getValidationDisplay()
                            .getFields()
                            .get('fields')['fields'].forEach(function (fieldName) {
                            var Validations = rowMap.get(fieldName, []);
                            Validations.push(' ');
                            rowMap = rowMap.set(fieldName, Validations);
                        });
                        mutable.set(entityId, rowMap);
                    });
                });
            });
            if (subEntityValidations_1.length > 0) {
                this._validationEmitter.emit();
            }
            this._validations = subEntityValidations_1.concat(functionalValidations_1);
            this.validationMessage.cache.clear();
        }
        else if (validationsCurrent) {
            this._validations = [];
            this._validationMessages = immutable_1.Map();
            this.validationMessage.cache.clear();
        }
    };
    InlineSisTableComponent.prototype.digOutColumnsMetaFields = function (metaFields) {
        if (this.colSystemNames && this.colSystemNames.length > 0) {
            this.columnMetaFields = [];
            var _loop_1 = function (colName) {
                var found = metaFields.find(function (meta) { return meta.getSystemName() === colName; });
                if (found) {
                    this_1.columnMetaFields.push(found);
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = this.colSystemNames; _i < _a.length; _i++) {
                var colName = _a[_i];
                _loop_1(colName);
            }
        }
        else {
            this.columnMetaFields = metaFields.filter(function (metaField) {
                return (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY ||
                    metaField.getType() ===
                        idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DOCUMENT ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.STRING ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DECIMAL ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MONEY);
            });
        }
        return this.columnMetaFields;
    };
    InlineSisTableComponent.prototype.addItemIfEmpty = function (entity) {
        if (!this.rowItems) {
            this.rowItems = [];
            this.rowItems.push(entity);
        }
    };
    InlineSisTableComponent.prototype.extractSubEntityValidations = function (validations) {
        var _this = this;
        return validations.filter(function (val) {
            return val
                .getRelatedMetaFieldIds()
                .every(function (metaFieldId) {
                return _this.columnMetaFields.some(function (columnField) {
                    return metaFieldId.getSystemName() ===
                        columnField.getSystemName() &&
                        metaFieldId.getMetaCategoryId().getSystemName() ===
                            columnField
                                .getMetaFieldId()
                                .getMetaCategoryId()
                                .getSystemName();
                });
            });
        });
    };
    InlineSisTableComponent.prototype.extractFunctionalValidations = function (validations) {
        var _this = this;
        return validations.filter(function (val) {
            return val.getValidationDisplay() &&
                val.getValidationDisplay().getDisplayType() ===
                    idm_validation_calculation_service_client_js_1.ValidationDisplayType.FUNCTIONAL &&
                val.getRelatedMetaFieldIds().length === 1 &&
                val.getRelatedMetaFieldIds()[0].getSystemName() ===
                    _this.fieldName &&
                val
                    .getRelatedMetaFieldIds()[0]
                    .getMetaCategoryId()
                    .getSystemName() === _this.mainCategoryName;
        });
    };
    InlineSisTableComponent.prototype.selectRow = function (row) {
        this.selectedRow = row;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], InlineSisTableComponent.prototype, "form", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [core_1.EventEmitter])
    ], InlineSisTableComponent.prototype, "onDocumentDeleted", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [core_1.EventEmitter])
    ], InlineSisTableComponent.prototype, "validationEmitter", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [core_1.EventEmitter])
    ], InlineSisTableComponent.prototype, "onDocumentUploaded", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InlineSisTableComponent.prototype, "id", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InlineSisTableComponent.prototype, "subFormKey", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], InlineSisTableComponent.prototype, "colSystemNames", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], InlineSisTableComponent.prototype, "isDeletable", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], InlineSisTableComponent.prototype, "actions", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], InlineSisTableComponent.prototype, "rowItems", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InlineSisTableComponent.prototype, "mainCategoryName", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InlineSisTableComponent.prototype, "categoryName", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], InlineSisTableComponent.prototype, "isAddable", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], InlineSisTableComponent.prototype, "validations", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], InlineSisTableComponent.prototype, "isReadonly", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InlineSisTableComponent.prototype, "deleteMessageTitleKey", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InlineSisTableComponent.prototype, "deleteMessageKey", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InlineSisTableComponent.prototype, "fieldName", null);
    InlineSisTableComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'inline-sis-table',
            template: require('./inline-sis-table.component.html'),
            providers: [sis_inline_communication_service_1.SisInlineCommunicationService],
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            settings: {
                main: settings_1.InlineSisTableSettingsComponent,
            },
            isFieldBound: true,
            template: "\n        <inline-sis-table\n            [id]=\"'%{id}'\"\n            [form]=\"form\"\n            [actions]=\"actions\"\n            [rowItems]=\"%{field}\"\n            [isReadonly]=\"%{isReadonly}\"\n            [subFormKey]=\"%{subFormKey}\"\n            [validations]=\"validations\"\n            [fieldName]=\"'%{field-name}'\"\n            [mainCategoryName]=\"category\"\n            [categoryName]=\"'%{field-category}'\"\n            [colSystemNames]=\"%{colSystemNames}\"\n            [isDeletable]=\"%{isDeletable}\" [isAddable]=\"%{isAddable}\"\n            (onDocumentUploaded)=\"actions.submitNestedDocument($event.id, $event.entity, $event.documentField, form)\"\n            (validationEmitter)=\"%{validationEmittedFor}\"\n            (onDocumentDeleted)=\"actions.removeNestedDocument($event.id, form, $event.entity, $event.documentField)\">\n        </inline-sis-table>\n    ",
            cellCount: 6,
            defaultActions: {
                validationEmittedFor: 'validationEmittedFor',
            },
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_de_service_client_js_1.DeService,
            idm_validation_calculation_service_client_js_1.ValidationService,
            material_1.MatDialog,
            skynet_store_locales_impl_1.LocaleService])
    ], InlineSisTableComponent);
    return InlineSisTableComponent;
}(models_1.BaseTable));
exports.InlineSisTableComponent = InlineSisTableComponent;
function validationCacheKeyResolver(id, name) {
    return id + "_" + name;
}
//# sourceMappingURL=inline-sis-table.component.js.map